export function messageOrderSuccessAction(bool) {
    return {
        type: "IS_VISIBLE_MESSAGE",
        payload: bool,
    };
}
